import { EDCServiceResponse, NServiceResponse } from "@/models/EstadoCuenta/NewServiceResponse";
import FechaCorte from "@/models/EstadoCuenta/FechaCorte";
import { AxiosResponse } from "axios";
import BaseService from "./BaseService";
import EDCB64 from "@/models/EstadoCuenta/EDFBase64";
import EstadoCuentaPDFRequest from "@/models/EstadoCuenta/EstadoCuentaPDFRequest";
import UserData from "@/models/CambioPassword/UserData";
import CambioPasswordRequest from "@/models/CambioPassword/CambioPasswordRequest";

export default class CambioPasswordService extends BaseService<any> {
    public constructor() {
      super("CambioPassword");
    }

    public async getUserData(
        userIdentity: string,
        uid:string,
        ip:string
      ): Promise<AxiosResponse<NServiceResponse<UserData>>> {
        let action: string =`getUserData/${userIdentity}/${uid}/${ip}`;
    
        return this.get(action);
      } 
      public async validateUsuario(
        payload: CambioPasswordRequest
      ): Promise<AxiosResponse<NServiceResponse<string>>> {
        let action: string =`ValidateUser`; 
        return this.post(action, { ...payload});
      }

      public async validateOTP(
        payload: CambioPasswordRequest
      ): Promise<AxiosResponse<NServiceResponse<string>>> {
        let action: string =`ValidateOtp`; 
        return this.post(action, { ...payload});
      }
      public async reestablecerPassword(
        payload: CambioPasswordRequest
      ): Promise<AxiosResponse<NServiceResponse<string>>> {
        let action: string =`ReestablecerPassword`; 
        return this.post(action, { ...payload});
      }
}   